import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client, ServiceProviderClient } from '../models/client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {
  
  apiUrl = 'v1/client/service-provider/';

  constructor(private http: HttpClient) { }

  public getServiceProviders() {
    return this.http.get<ServiceProviderClient[]>(environment.apiUrl + this.apiUrl + 'list');
  }

  public getServiceProviderDetails(clientId: number) {
    return this.http.get<ServiceProviderClient>(environment.apiUrl + this.apiUrl + clientId);
  }

  public updateServiceProvider(provider: ServiceProviderClient) {
    return this.http.post<ServiceProviderClient>(environment.apiUrl + this.apiUrl + provider.clientId, provider);
  }

  public requestTechnicianStatusUpdate(clientId: number) {
    return this.http.put<Date>(environment.apiUrl + this.apiUrl + clientId + "/requestStatus", {});
  }

  public updateSPWAGroupLink(clientId: number, whatsappGroupLink: string, whatsappGroupName: string) {
    console.log("Updating WhatsApp group link for client ID:", clientId, "New Link:", whatsappGroupLink);
    return this.http.post<void>(environment.apiUrl + this.apiUrl +  "updateWAGroupLink/" + clientId, { "whatsappGroupLink": whatsappGroupLink, "whatsappGroupName": whatsappGroupName });
  }

  public removeSPConnection(clientId: number) {
    return this.http.delete<void>(environment.apiUrl + this.apiUrl + clientId);
  }
}
